import { render, staticRenderFns } from "./ImgMessage.vue?vue&type=template&id=656dc928&scoped=true&"
import script from "./ImgMessage.vue?vue&type=script&lang=js&"
export * from "./ImgMessage.vue?vue&type=script&lang=js&"
import style0 from "./ImgMessage.vue?vue&type=style&index=0&id=656dc928&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656dc928",
  null
  
)

export default component.exports